/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { UploadUserFileRequestToJSON, UserIncidentImageDtoFromJSON, UserIncidentImageDtoPageResponseFromJSON, } from '../models/index';
/**
 *
 */
export class CreatorIncidentImagesApi extends runtime.BaseAPI {
    /**
     */
    creatorIncidentImagesCreateFileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentImagesCreateFile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-images`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UploadUserFileRequestToJSON(requestParameters.uploadUserFileRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentImagesCreateFile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentImagesCreateFileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentImagesDeleteFileByUploadedFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentImagesDeleteFileByUploadedFileId.');
            }
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentImagesDeleteFileByUploadedFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-images/{uploadedFileId}`.replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))).replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    creatorIncidentImagesDeleteFileByUploadedFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.creatorIncidentImagesDeleteFileByUploadedFileIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    creatorIncidentImagesGetFileByUploadedFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentImagesGetFileByUploadedFileId.');
            }
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentImagesGetFileByUploadedFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-images/{uploadedFileId}`.replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))).replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentImagesGetFileByUploadedFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentImagesGetFileByUploadedFileIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentImagesPaginateFilesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentImagesPaginateFiles.');
            }
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-images`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageDtoPageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentImagesPaginateFiles(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentImagesPaginateFilesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
